//mobile footer menu

$('.footer-block--menu .footer-block__heading').on('click', function(){
    $(this).siblings().toggleClass('footer-block--menu-open');
    $(this).toggleClass("footer-block--heading-open");
})

//Animate on scroll initiation
$(function() {
    AOS.init(); // Animation AOS library init
});
// Wish list (Dream list) - Inject print button
$(document).on("click",".preheader_links[href='#swym-wishlist']",function(event){
  var changeFlag = true
  if (changeFlag){
    var intervalFn = setInterval(function (){
      if ($('.swym-wishlist-context-menu').length == 1){
        $('.swym-wishlist-context-menu.swym-icon.swym-is-button').click()
        if ( $('#dreamlist_print_btn').length == 0){
          $('.swym-wishlist-detail-header').append('<button onClick="printPageArea(`dreamlist`)" id="dreamlist_print_btn" class="btn swym-wishlist-context-menu-item swym-print swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span><span>Print / Save</span></button>')
          changeFlag = false;
          clearInterval(intervalFn)
          // console.log('interval.. ')
        }
      }
    }, 500);
  }
})
  
  
function printPageArea(area = null){
  if (area == 'dreamlist'){
    $('body').addClass('printarea_dreamlist')
  }else{
    $('body').removeClass('printarea_dreamlist')
  }
  window.print()
}



function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// waitForElm('.strmpr-search-result-filters').then((elm) => {
//   setTimeout(function() { 
//   $('.strmpr-filter-toggle-name-0 label').click();
//   }, 1000);
// });




$(document).ready(function(){
  // on Product page
  // if ($('.js-zoom-enabled').length > 0 || (window.innerWidth < 750 && $('.pt.product__media.enable_zoom_lightbox').length > 0) ){
  //   $('.pt.product__media.enable_zoom_lightbox').addClass('js-zoom-enabled');
  //   $('.js-zoom-enabled').each( function(){
  //     let zoomUrl = $(this).data('zoom');
  //     $(this).zoom({
  //       url: zoomUrl
  //     });
  //   })
  // }
  // $(window).resize(function() {
  //   if ( window.innerWidth < 750 ) {
  //     $('.pt.product__media.enable_zoom_lightbox').addClass('js-zoom-enabled');
  //     $('.enable_zoom_lightbox.js-zoom-enabled').each( function(){
  //       let zoomUrl = $(this).data('zoom');
  //       $(this).zoom({
  //         url: zoomUrl
  //       });
  //     })
  //   }else {
  //     $('.pt.product__media.enable_zoom_lightbox').removeClass('js-zoom-enabled');
  //   }
  // })

  // Product template Okendo review section - Jun 2024
  $('.template-product div[id^="shopify-block-okendo_reviews_carousel_"]').hide(); // 1. Hide okendo review first
  // 2. Show if the section has slider content. 
  waitForElm('.template-product .okeReviews .oke-reviewCarousel-slider').then((elm) => {
    $('.template-product div[id^="shopify-block-okendo_reviews_carousel_"]').show();
  });

  $('.preheader_links').on('click', function(){
    console.log('wishlist');
    var existCondition = setInterval(function() {
      if ($('.swym-value').length) {
        console.log("Exists!");
         clearInterval(existCondition);
        
        $('.swym-value').each(function(){
           var thisText = $(this).text();
           $(this).text('');

           var removeNZD = thisText.slice(3, -3);
      
           $(this).empty();
            $(this).text('$'+removeNZD);
           //console.log(removeNZD);
        });
         
       

      }
     }, 600); // check every 100ms
  });

  // Global - Announcement bar slider
  if ( $(window).width() < 990 ) {
    // active Slider
    announcementBarMobileSlider()
  } else {
    // destory slider
    disableMobileCarousel('#shopify-section-announcement-bar')
  }
});


  $(function() {


    $('body').on('click', '.variant-wrapper', function(){
      $('.variant-picker').toggle();
      $('.size-option-variant .ico').toggle();
      $('#size-selector').addClass('hidden')
      $('#btn-product-size').removeClass('btn-icon')
    });

    $('body').on('click', '.product-size-selector-wrapper', function(){
      console.log('product-size-selector-wrapper');
      $('.variant-picker').hide(); 
      $('.size-option-variant .ico').hide();
    });

   

    $('body').on('click', '.variant-picker li ', function(){
      console.log('clicked');
      let getVID = $(this).data('vid');
      window.history.replaceState(null, null, `?variant=${getVID}`);
      location.reload();
    });

    if (window.location.href.indexOf("variant") > -1) {
      getVarName = $('.ul-selected').text();
      $('.variant-name').text(getVarName);
    } else {
      getVarName = $('.variant-picker li').first().text();
      $('.variant-name').text(getVarName);
    }
  });

// new announcement bar slider
$(window).resize(function() {
  if ( $(window).width() < 990 ) {
    // active Slider
    announcementBarMobileSlider()
  } else {
    // destory slider
    disableMobileCarousel('#shopify-section-announcement-bar')
  }
})

function announcementBarMobileSlider(){
  let x = '#shopify-section-announcement-bar';
  $(x).addClass('owl-carousel').addClass('owl-theme');
  $(x).owlCarousel({
    loop: true,
    dots: false,
    autoWidth: false,
    autoHeight: false,
    items:1,
    nav: false,
    autoplay:true,
    // autoplayTimeout:3000,
    autoplayHoverPause:true,
    animateOut: 'slideOutUp',
    animateIn: 'slideInUp', 
    
    // smartSpeed:3000
  })
  // .trigger('refresh.owl.carousel');
}

function disableMobileCarousel(x){
  $(x).trigger('destroy.owl.carousel');
  $(x).removeClass('owl-carousel');
}

// Check if the device is a mobile device
function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

// Function to add slick slider to elements with class .js-mobile-slider
function addSlickSliderToMobile() {
    if (isMobileDevice()) {
        $('.js-mobile-slider').each(function() {
            $(this).slick({
                // Slick slider options
                slidesToShow: 2.5,
                slidesToScroll: 3,
                dots: true,
                centerMode: true,
                adaptiveHeight: true
            });
        });
        $('.js-mobile-slider-none-overlap').each(function() {
            $(this).slick({
                // Slick slider options
                slidesToShow: 3,
                slidesToScroll: 3,                dots: true,
            });
        });
        $('.js-mobile-slider-single-item').each(function() {
            $(this).slick({
                // Slick slider options
                slidesToShow: 3,
                slidesToScroll: 3,                
                dots: true,
            });
        });
        $('.js-mobile-slider-one-per').each(function() {
            $(this).slick({
                // Slick slider options
                slidesToShow: 1,
                slidesToScroll: 1,                
                dots: true,
            });
        });
    }
}

// Execute the function when the DOM is ready
$(document).ready(function() {
  addSlickSliderToMobile();
});



$(document).ready(function() {
    $('.mega-menu').mouseenter(function() {
        $(this).attr('open', '');
        $('.slideshow__controls').hide();
    });

    $('.mega-menu').mouseleave(function() {
        $(this).removeAttr('open');
        $('.slideshow__controls').show();
    });
});

// window.addEventListener('scroll', function() {
//   var body = document.body;
//   var scrollPosition = window.scrollY;
//   var scrollThreshold = window.innerWidth <= 768 ? 50 : 1; // Adjust threshold for mobile devices
  
//   if (scrollPosition > scrollThreshold) {
//     body.classList.add('fixed-header');
//   } else {
//     body.classList.remove('fixed-header');
//   }
// });

function paymentsWidget(e){
  let isActive = $(e).hasClass('active') ? true : false;

  if (isActive){
    $(e).removeClass('active') // hide 
  }else {
    $(e).addClass('active')// Show
  }
}

function customDecreaseItem(product){
  let widgetID = ($(event.target).parents('.rebuy-widget').attr('id')).replaceAll('rebuy-widget-', '')
  let pID = product.id;
  let selectBox = $(event.target).parents('.qty-custom-wrap').find('.custom-dynamic-bundle-qty-select')
  let qtyInput = $(event.target).parents('.product-quantity').find('.custom-dynamic-bundle-qtyinput')
  let currentQty = selectBox.val()
  let updatedQty = (1*currentQty) - 1

  // let minQty = 1
  
  // // Check maximum value and block if it's over the max value
  // if (currentQty <= minQty){
  //   // console.log('1 is the minimum !!')
  //   return false;
  // }
  // Update (hidden) select box
  selectBox.val(updatedQty).trigger('change')
  qtyInput.text(`${updatedQty}`)

  updateRebuyWidget(widgetID, pID, updatedQty);
}

function customIncreaseItem(product){
  let widgetID = ($(event.target).parents('.rebuy-widget').attr('id')).replaceAll('rebuy-widget-', '')
  let pID = product.id;
  let selectBox = $(event.target).parents('.qty-custom-wrap').find('.custom-dynamic-bundle-qty-select')
  let qtyInput = $(event.target).parents('.product-quantity').find('.custom-dynamic-bundle-qtyinput')
  let currentQty = selectBox.val()
  let updatedQty = (1*currentQty) + 1

  let maxQty = selectBox.find('option').length
  
  // Check maximum value and block if it's over the max value
  if (currentQty >= maxQty){
    // console.log('max value reached !!!')
    return false;
  }
  // Update (hidden) select box
  selectBox.val(updatedQty).trigger('change')
  qtyInput.text(`${updatedQty}`)

  updateRebuyWidget(widgetID, pID, updatedQty);
}

function updateRebuyWidget(widgetID, pID, updatedQty){
  console.log('updateRebuyWidget ->',widgetID, pID, updatedQty)

  let widgetList = Rebuy.widgets

  widgetList.forEach((e)=>{
    if (e.id == widgetID){
      let products = e.data.products;
      products.forEach((p)=>{
        if (p.id == pID){
          p.quantity = updatedQty
          console.log('!!!!!!', p.id, p.quantity)
        }
      });
    }
  })
}

async function getCart(){
  try {
    const response = await fetch('/cart.js');
    return await response.json();
  }
  catch (err) {
    console.log('fetch failed', err);
  }
}

async function addToCartAjax(variant_id, quantity){
  let item = {
    id: variant_id,
    quantity: quantity
  };
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(item),
    });
    const jsonResponse = await response.json();
    let updatedCart = await getCart()
    console.log('#addToCartAjax -  successful', jsonResponse);
    

    // Set - Cart notification
    const CartNotificationAjax = new CartNotification();
    let optionsHTML = ``
    for (let i = 0; i < jsonResponse.options_with_values.length; i++){
      optionsHTML += `<div class="product-option"><dt class="opt">${jsonResponse.options_with_values[i].name}: </dt><dd>${jsonResponse.options_with_values[i].value}</dd></div>`
    }
    let responseHTML = `<div class="cart-notification-product__image global-media-settings">
                          <img src="${jsonResponse.featured_image.url}" alt="${jsonResponse.title}" width="70" loading="lazy">
                        </div>
                        <div>
                          <h3 class="cart-notification-product__name">${jsonResponse.title}</h3>
                          <dl>${optionsHTML}</dl>
                        </div>`
    $('#cart-notification-product').append(responseHTML)
    
    $('#cart-notification-button').text(`View My Cart (${updatedCart.item_count})`)
    // $('.cart-count-bubble span:first-child').text(updatedCart.item_count)
    // $('.cart-count-bubble span.visually-hidden').text(`${updatedCart.item_count} items`)
    
    CartNotificationAjax.open()

    return jsonResponse;
  }
  catch (err) {

    console.log('#addToCartAjax - fetch failed ', err);
  }
}

$(document).ready(function() {
  $('.not-color-dropdown .form__label').on('click', function() {
    //console.log('hihi');
    $('.dropdown-styling').not($(this).next('.dropdown-styling')).hide();
    $(this).next('.dropdown-styling').toggle();
  });
  $('.not-color-dropdown label').on('click', function() {
    $(this).parents('.dropdown-styling').hide();
  });

  $(document).on('click', function(event) {
    if (!$(event.target).closest('.not-color-dropdown').length) {
      $('.not-color-dropdown .dropdown-styling').hide();
    }
  });
 

  $('.comfort-popup-toggle, .comfort-popup-toggle-mobile').on('click', function(event) {
    console.log('init comfort popup');

    $('.comfort-popup-wrap').show();
  });

  $('.close-btn, .popup-overlay').on('click', function(event) {
    $('.comfort-popup-wrap').hide();
  });
});

//hide okendo star block when no reviews
if (!$('.template-product  .oke-stars').length) {
  $('[data-oke-star-rating]').hide();
}

$(document).ready(function() {
  $('body').on('click', '.rebuy-product-options', function() {
    $(this).addClass('option-selected');
    $(this).next().addClass('active');
  });
});


// Event listener - rebuy smart cart hide function
document.addEventListener('rebuy:smartcart.hide', (event) => {
  // FOCUS to the logo img: To block focusing to the FS filter
  // Check if the element exists and is focusable
  var logoElement = document.querySelector('.header__heading-logo');
  if (logoElement) {
    // Optionally, add tabindex if it's not a focusable element
    if (!logoElement.hasAttribute('tabindex')) {
        logoElement.setAttribute('tabindex', '0'); // Make it focusable
    }
    
    // Focus on the element
    logoElement.focus();
    console.log('####logo focused-- rebuy callback')
}
});

// Product form submission
let productApiDataSubmitted = false;
const ZYBER_URL = 'https://bru.zyberclients.co.nz';
const SECURITY_KEY = 'eFzjlD1!pwH46*MvaX*JDfa6OO58OJR!2OeshlPiP7SJoe%skrzoqyulq$xHyDe2oMNAYqX&cOQ@tsBfvd3*@0V#cpqMMmHjMkN';

function productFormSubmission(obj, e) {
  if (!productApiDataSubmitted) {
    e.preventDefault();

    var first = $(obj).closest('form').find('[name="contact[first_name]"]').val(),
        last = $(obj).closest('form').find('[name="contact[last_name]"]').val(),
        email = $(obj).closest('form').find('[name="contact[email]"]').val(),
        phone = $(obj).closest('form').find('[name="contact[phone]"]').val(),
        streetAddress = $(obj).closest('form').find('[name="contact[street_address]"]').val(),
        city = $(obj).closest('form').find('[name="contact[city]"]').val(),
        postcode = $(obj).closest('form').find('[name="contact[postcode]"]').val(),
        preferredStore = $(obj).closest('form').find('[name="contact[preferred_store]"]').val(),
        selection = $(obj).closest('form').find('[name="contact[selection]"]').val(),
        message = $(obj).closest('form').find('[name="contact[message]"]').val(),
        optedIn = $(obj).closest('form').find('[name="contact[permission]"]').is(':checked'),
        product = $(obj).closest('form').find('[name="contact[submitted]"]').val();
    
    // Format phone number before validation
    var formattedPhone = formatPhoneNumber(phone); // Format the phone number
    var phoneValid = phoneValidation(formattedPhone); // Validate the formatted phone number
    var emailValid = emailValidation(email); // Validate the email

    // Reset previous error messages
    $('.error-message').remove(); // Remove all previous error messages

    var valid = true; // Flag to track validation status

    // Validate fields and display error messages
    if (!first) {
      valid = false;
      $(obj).closest('form').find('[name="contact[first_name]"]').after('<div class="error-message" style="color:red;">First name is required.</div>');
    }
    if (!email || !emailValid) {
      valid = false;
      $(obj).closest('form').find('[name="contact[email]"]').after('<div class="error-message" style="color:red;">Please enter a valid email address.</div>');
    }
    if (!phoneValid) {
      valid = false;
      $(obj).closest('form').find('[name="contact[phone]"]').after('<div class="error-message" style="color:red;">Please enter a valid mobile number.</div>');
    }
    if (!streetAddress) {
      valid = false;
      $(obj).closest('form').find('[name="contact[street_address]"]').after('<div class="error-message" style="color:red;">Street address is required.</div>');
    }
    if (!city) {
      valid = false;
      $(obj).closest('form').find('[name="contact[city]"]').after('<div class="error-message" style="color:red;">City is required.</div>');
    }
    if (!postcode) {
      valid = false;
      $(obj).closest('form').find('[name="contact[postcode]"]').after('<div class="error-message" style="color:red;">Postcode is required.</div>');
    }
    if (!preferredStore) {
      valid = false;
      $(obj).closest('form').find('[name="contact[preferred_store]"]').after('<div class="error-message" style="color:red;">Preferred store is required.</div>');
    }
    if (!selection) {
      valid = false;
      $(obj).closest('form').find('[name="contact[selection]"]').after('<div class="error-message" style="color:red;">Selection is required.</div>');
    }
    if (!message) {
      valid = false;
      $(obj).closest('form').find('[name="contact[message]"]').after('<div class="error-message" style="color:red;">Message is required.</div>');
    }

    if (valid) {
      var params = {
        "firstName": first,
        "lastName": last,
        "email": email,
        "phone": formattedPhone,  // Use the formatted phone number
        "streetAddress": streetAddress,
        "city": city,
        "postcode": postcode,
        "preferredStore": preferredStore,
        "selection": selection,
        "message": message,
        "product": product,
        "optedIn": optedIn ? 1 : 0
      };

      console.log("#######--------", params);

      $.ajax({
        type: 'POST',
        url: ZYBER_URL + '/api/form-submission/product-enquiry',
        dataType: 'json',
        data: params,
        headers: {
          'x-api-key': SECURITY_KEY
        }
      }).done(function(response) {
        console.log('#productFormSubmission Ajax - response:', response);
        $('.product-enquire-form').hide(); // Hide form
        $('.product-enquire-form').after('<div class="success-message"><span style="font-size: 24px; font-family: Arial, Helvetica, sans-serif; font-weight: bold;">Thank You for your enquiry!</span><br> <p style="text-align: center; font-size: 14px; font-family: Arial, Helvetica, sans-serif; font-weight: 400;">One of our team members will be in touch with you shortly</p></div>'); // Show success message
   
        productApiDataSubmitted = true; // Only affect product form submission
        $('#submit_contactForm').click();
      }).fail(function(jqXHR, textStatus) {
        console.log('#productFormSubmission Ajax - failed:', jqXHR, textStatus);
      });

    }
  }
}

let contactApiDataSubmitted = false;

function contactFormSubmission(obj, e) {
  if (!contactApiDataSubmitted) {
    e.preventDefault();

    var first = $(obj).closest('form').find('[name="contact[first_name]"]').val(),
        last = $(obj).closest('form').find('[name="contact[last_name]"]').val(),
        email = $(obj).closest('form').find('[name="contact[email]"]').val(),
        phone = $(obj).closest('form').find('[name="contact[phone]"]').val(),
        preferredStore = $(obj).closest('form').find('[name="contact[preferred_store]"]').val(),
        message = $(obj).closest('form').find('[name="contact[message]"]').val(),
        emailValid = emailValidation(email); // Using the same email validation function

    // Format the phone number before validation
    var formattedPhone = formatPhoneNumber(phone);
    var phoneValid = phoneValidation(formattedPhone); // Using the formatted phone number

    // Log all form data and validation results (for debugging purposes)
    console.log('Form Data:', {
      first: first,
      last: last,
      email: email,
      phone: formattedPhone,
      preferredStore: preferredStore,
      message: message,
      emailValid: emailValid,
      phoneValid: phoneValid
    });

    // Reset previous error messages
    $('.error-message').remove(); // Remove previous error messages

    var valid = true; // Flag to track if form is valid

    // Validate fields and display error messages
    if (!first) {
      valid = false;
      $(obj).closest('form').find('[name="contact[first_name]"]').after('<div class="error-message" style="color:red;">First name is required.</div>');
    }
    if (!email || !emailValid) {
      valid = false;
      $(obj).closest('form').find('[name="contact[email]"]').after('<div class="error-message" style="color:red;">Please enter a valid email address.</div>');
    }
    if (!phoneValid) {
      valid = false;
      $(obj).closest('form').find('[name="contact[phone]"]').after('<div class="error-message" style="color:red;">Please enter a valid mobile number.</div>');
    }
    if (!preferredStore) {
      valid = false;
      $(obj).closest('form').find('[name="contact[preferred_store]"]').after('<div class="error-message" style="color:red;">Preferred store is required.</div>');
    }
    if (!message) {
      valid = false;
      $(obj).closest('form').find('[name="contact[message]"]').after('<div class="error-message" style="color:red;">Message is required.</div>');
    }

    if (valid) {
      var params = {
        "firstName": first,
        "lastName": last,
        "email": email,
        "phone": formattedPhone,
        "preferredStore": preferredStore,
        "message": message
      };

      console.log("#######-------- Form Submission Params:", params);

      $.ajax({
        type: 'POST',
        url: ZYBER_URL + '/api/form-submission/contact-us',
        dataType: 'json',
        data: params,
        headers: {
          'x-api-key': SECURITY_KEY
        }
      }).done(function(response) {
        console.log('#contactFormSubmission Ajax - response:', response);
        contactApiDataSubmitted = true; // Only affect contact form submission
        $('#ContactForm').trigger("reset"); // Reset the form on successful submission
        $('#ContactForm').hide(); // Hide form
        $('#ContactForm').after('<div class="success-message"><span style="font-size: 24px; font-family: Arial, Helvetica, sans-serif; font-weight: bold;">Thank You for your enquiry!</span><br> <p style="text-align: center; font-size: 14px; font-family: Arial, Helvetica, sans-serif; font-weight: 400;">One of our team members will be in touch with you shortly</p></div>'); // Show success message

      }).fail(function(jqXHR, textStatus) {
        console.log('#contactFormSubmission Ajax - failed:', jqXHR, textStatus);
        // Handle error here
      });

    } else {
      // If the form is invalid, log the validation result (optional)
      console.log('Form Validation Failed:', {
        firstValid: first,
        emailValid: emailValid,
        phoneValid: phoneValid,
        preferredStoreValid: preferredStore,
        messageValid: message
      });
    }
  }
}

// Format the phone number before passing it to validation
function formatPhoneNumber(phone) {
    var formattedPhone = phone.trim();

    // Ensure the phone starts with +64 and remove leading zero if necessary
    if (!formattedPhone.startsWith("+64")) {
        formattedPhone = "+64" + formattedPhone.replace(/^0+/, ""); // Add +64 and remove any leading zeros if not already present
    }

    // If the phone starts with +64 and the next character is 0, remove that 0
    if (formattedPhone.startsWith("+64") && formattedPhone.charAt(3) === "0") {
        formattedPhone = "+64" + formattedPhone.slice(4); // Remove the leading 0 after +64
    }

    console.log('Formatted Phone Number:', formattedPhone); // Log formatted phone number

    return formattedPhone;
}

// Email validation function
function emailValidation(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex
  return re.test(String(email).toLowerCase());
}

// Phone validation function
function phoneValidation(phone) {
    console.log('Phone to validate:', phone); // Debugging line

    // Validate the phone number format using a regex for +64 and 9 digits after it
    const phoneFormatRegex = /^\+64\d{9,10}$/; // Phone number should start with +64 and exactly  digits after

    // Check if the phone number matches the required format and length
    if (phoneFormatRegex.test(phone)) {
        console.log('Phone validation passed:', phone); // Log successful validation
        return true; // Valid phone number
    } else {
        console.log('Phone validation failed:', phone); // Log failed validation
        return false; // Invalid phone number
    }
}
